module.exports = __webpack_public_path__ + "img/tp4.e6f01404.jpg";